export class BoxCounterUpdatedEvent {
	public constructor(
		public boxId: string,
		public count: number
	) {}
}
